var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrexo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    rx: 4,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5000_2665)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_5000_2665)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.05291 8.49266H8.82564C8.64228 8.25214 8.53657 7.96145 8.52261 7.65933V7.05327C8.52261 7.05327 8.63337 6.7813 8.52261 6.14418L8.37109 5.68963V5.23509C8.37109 5.23509 8.39526 5.01721 8.59837 5.00781H8.82564C8.82564 5.00781 9.142 5.01721 9.12867 5.23509V5.68963C9.12867 5.68963 8.99049 6.44577 9.20443 7.12902V7.65933C9.20443 7.65933 9.25852 8.35198 9.05291 8.49266Z",
    fill: "#FF6F3F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.05344 8.49121H8.82617V9.02151H9.05344V8.49121Z",
    fill: "#FF6F3F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.97712 8.94531H8.90137V9.47562H8.97712V8.94531Z",
    fill: "#FF6F3F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.8556 8.2661H11.6284C11.445 8.02558 11.3393 7.73489 11.3253 7.43277V6.8267C11.3253 6.8267 11.4361 6.55473 11.3253 5.91761L11.1738 5.46307V5.00852C11.1738 5.00852 11.198 4.79064 11.4011 4.78125H11.6284C11.6284 4.78125 11.9447 4.79064 11.9314 5.00852V5.46307C11.9314 5.46307 11.7932 6.2192 12.0072 6.90246V7.43277C12.0072 7.43277 12.0613 8.12542 11.8556 8.2661Z",
    fill: "#FF6F3F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8562 8.26465H11.6289V8.79495H11.8562V8.26465Z",
    fill: "#FF6F3F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.7799 8.71875H11.7041V9.24905H11.7799V8.71875Z",
    fill: "#FF6F3F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.3408 7.81181H10.1135C10.0131 7.59222 9.95597 7.35531 9.94533 7.11408V6.64135C9.94533 6.64135 10.0317 6.42923 9.94533 5.93226L9.82715 5.57772V5.22317C9.83151 5.17763 9.85159 5.13504 9.88394 5.10269C9.91629 5.07034 9.95888 5.05026 10.0044 5.0459H10.1817C10.1817 5.0459 10.4284 5.05347 10.4181 5.22317V5.57772C10.4181 5.57772 10.3105 6.16726 10.4771 6.70044V7.11423C10.4771 7.11423 10.5012 7.70203 10.3408 7.81181Z",
    fill: "#FF6F3F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.1133 7.8125H10.3406V8.19129H10.1133V7.8125Z",
    fill: "#FF6F3F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.3004 8.11914H10.2412V8.53111H10.3004V8.11914Z",
    fill: "#FF6F3F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5982 6.59883L14.3558 6.2958V5.31095C14.3558 5.31095 14.5332 2.58876 11.174 2.7352H8.37093L7.31032 2.81095C7.31032 2.81095 5.14615 2.80088 5.18911 4.55338L5.71941 15.311C5.71941 15.311 5.84312 17.3917 7.68911 17.2806C7.68911 17.2806 11.0401 17.3766 13.4467 16.3716C13.4467 16.3716 14.7219 15.8311 14.7346 14.4019L14.6588 11.2958C14.6588 11.2958 14.6916 10.0281 13.4467 10.5382L11.9315 11.0685L11.78 11.9019C11.78 11.9019 12.4795 11.4978 12.8406 11.4473C12.8406 11.4473 13.9795 11.225 13.9012 12.1291C13.9012 12.1291 14.059 13.2907 13.2952 13.72C13.2952 13.72 12.4302 14.4397 10.4164 14.6291C10.4164 14.6291 10.448 14.225 10.1891 14.0231C10.1891 14.0231 10.1702 13.3413 10.9467 13.1897V12.3564C10.9467 12.3564 9.80403 12.2428 10.2649 11.0685L9.6588 10.5382L9.35577 10.7655C9.35577 10.7655 8.86964 10.9422 8.67396 10.614L8.44668 10.0079H7.61335C7.61335 10.0079 7.56918 10.7402 7.08305 10.7655C6.9478 10.7875 6.80932 10.7785 6.67807 10.7392C6.54682 10.6998 6.42624 10.6311 6.32547 10.5382L6.0982 5.00792C6.0982 5.00792 6.04138 3.82103 7.61335 3.7958H11.5527C11.5527 3.7958 13.352 3.64429 13.5224 5.31095L13.5982 6.59883Z",
    fill: "#FF6F3F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.14418 14.0227C8.77177 14.0227 9.28054 13.514 9.28054 12.8864C9.28054 12.2588 8.77177 11.75 8.14418 11.75C7.51658 11.75 7.00781 12.2588 7.00781 12.8864C7.00781 13.514 7.51658 14.0227 8.14418 14.0227Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6432 16.2757C10.9256 16.2757 11.1546 16.0467 11.1546 15.7643C11.1546 15.4819 10.9256 15.2529 10.6432 15.2529C10.3608 15.2529 10.1318 15.4819 10.1318 15.7643C10.1318 16.0467 10.3608 16.2757 10.6432 16.2757Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9087 3.18848H8.78746C8.7247 3.18848 8.67383 3.23935 8.67383 3.30211C8.67383 3.36487 8.7247 3.41575 8.78746 3.41575H10.9087C10.9714 3.41575 11.0223 3.36487 11.0223 3.30211C11.0223 3.23935 10.9714 3.18848 10.9087 3.18848Z",
    fill: "#FF6F3F"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5000_2665"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "white",
    transform: "translate(2.5 2.5)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_5000_2665"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 9.84848,
    height: 15,
    fill: "white",
    transform: "translate(5 2.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrexo);
export default __webpack_public_path__ + "static/media/prexo.40330e6fc727c96b8e114b7d5bf7ec91.svg";
export { ForwardRef as ReactComponent };